<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/8.jpg"
      class="banner"
    />
    <img
      class="oldWorld"
      @click="go"
      :src="oldWorldImg"
      @mouseover="mouseChange(false)"
      @mouseleave="mouseChange(true)"
      alt=""
    />
    <!-- 产品介绍 -->
    <!-- <div class="introduce">
      <div>
        <div></div>
        <div class="title">方案介绍</div>
        <div class="desc">
          基于虚拟现实技术VR开发的VR安全体验系统，体验者通过VR头显设备，置身于施工现场，以第一和第三视角，分别体验不同安全事故伤害的严重后果，并通过对事故原因、防范措施的简要交互问题，在震撼体验同时，进一步增加安全意识。
        </div>
      </div>
    </div> -->
    <div class="introduce">
      <div class="title">产品介绍</div>
      <div class="line" id="isMobileF"></div>
      <div class="content">
        <div>
          格灵世界是全球领先的在线STEAM课程平台，少年儿童处在培养科学素质和创新思维的黄金时期，格灵世界旨在引导他们利用已掌握的知识和工程技术，采用科学的思维与实践方式解决实际问题。从而培养学生们的高效创新能力，提高竞争力。我们现在做的一切，都是为了帮助孩子们在将来能够从事今天尚未出现的工作。掌握今天尚未发明的技术，解决今天尚未遇到的问题。
        </div>
        <div>
          格灵世界期望凭借科技的力量，构建“教育与社会发展保持现实性和前瞻性相统一“的活动平台。促进青少年知识、能力、思维，与实践的全面发展，培养科学素养和创新能力，提高对自身能力的深度认知，为创造更美好的智能时代作出贡献。
        </div>
      </div>
      <van-image
        fit="cover"
        class="img"
        src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/5.png"
      />
    </div>
    <!-- 产品特色 -->
    <Constitute :title="'产品特色'" :constitute="constitute"></Constitute>
    <!-- STEAM课程 -->
    <div class="details">
      <div class="title">多场景跨学科课程内容</div>
      <div class="content">
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/7.png"
          alt=""
        />
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/6.jpg"
          alt=""
        />
      </div>
      <div class="desc">
        利用微生物馆的环境和素材开展活动，用编程语句模拟微生物的繁殖。学生在学习的过程中，了解微生物是什么、繁殖方式和对人类的危害及益处等。
        用格灵世界软件搭建浅海生物生态系统。学习海底地形、海洋中生物分布、珊瑚等知识，并将软件中的元素科学正确的放置浅海生态系统中。
      </div>
    </div>
    <!-- 线下实用场景 -->
    <!-- <div class="tiny">
      <div class="title">线下实用场景</div>
      <div class="content">
        <div class="list" v-for="item of list" :key="item">
        <img src="" alt="" />
      </div>
      </div>
    </div> -->
    <!-- 客户案例 -->
    <Eg :list="listK12"></Eg>
  </div>
</template>
<script>
import Eg from '@/component/example';
import Constitute from '@/component/constitute';
export default {
  components: {
    Eg,
    Constitute
  },
  data() {
    return {
      list: [1, 2, 3, 4],
      constitute: [
        {
          title: '科学的评测',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/1.png',
          desc: '3项专业能力评测，实时跟踪学生的学习路径，助力孩子成长'
        },
        {
          title: 'PBL制学习',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/2.png',
          desc:
            '以学生为主体，启发式教育，调动学生积极性增强协作、交际能力'
        },
        {
          title: '跨学科教学',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/3.png',
          desc: '打破学科边界，涵盖多领域知识，培养孩子多元化解决问题的能力'
        },
        {
          title: '十二套主题',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/4.png',
          desc:
            '拥有十二大主题场馆，丰富的课程，让学生在学习的过程中不断释放创造力'
        }
      ],
      listK12: [
        {
          title: '北京朝阳实验小学',
          desc:
            'VR未来课堂将虚拟现实技术与实际教学知识点紧密结合，打造与实际教育教学高度集合的高仿真、沉浸式、可交互的解决方案，推展学习空间，提高学习兴趣，增强学习主动探究能力、创造力',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/5.jpg'
        },
        {
          title: '北京清华大学附属中学',
          desc:
            '智慧宫是一款基于 5G 6DOF VR 模拟物、化、生实验场景，提供规范的实验内容、自由化交互， 结合学科实验设计的一套符合课程标准、考试要求的实验课程，该产品既能教学、也能考核。不仅解决了传统实验中遇到的高危操作、实验准备周期长、实验室不足等一系列问题，而且还能够进行批量考核',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/6.jpg'
        },
        {
          title: '青岛市崂山区沙子口小学',
          desc:
            '覆盖中小学语文、英语、科学、物理、化学、生物、地理、历史、安全、国学、心理等内容，跨平台使用，支持老师备课、课程管理、设备监督，推动学校教育信息化建设，促进教育资源共享，推动教育资源均衡',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/eg/1.jpg'
        }
      ],
      oldWorldImg:
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/old.png'
    };
  },
  methods: {
    go() {
      window.open('https://g.growlib.com/')
    },
    mouseChange(type){
      this.oldWorldImg = type ? 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/old.png' : 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/oldHover.png'
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  position: relative;
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .oldWorld {
    position: absolute;
    margin-top: -50px;
    top: 450px;
    right: 50px;
    z-index: 1;
    cursor: pointer;
    width: 135px;
  }
  .introduce {
    width: 1200px;
    background: #9aa4b9;
    margin: 0 auto;
    margin-top: 120px;
    margin-bottom: 36px;
    position: relative;
    padding: 25px;
    box-sizing: border-box;
    color: #fff;
    .title {
      font-size: 36px;
      font-weight: 500;
    }
    .content {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      > div {
        font-size: 22px;
        color: #ffffff;
        line-height: 36px;
        width: 528px;
        text-align: justify;
        text-indent: 2em;
      }
      > div:nth-child(2) {
        text-indent: 2em;
        padding-top: 100px;
        width: 561px;
        margin-right: 16px;
        text-align: justify;
      }
    }
    .img {
      position: absolute;
      top: -61px;
      right: 40px;
      border: 12px solid #fff;
      // padding: 16px;
      box-sizing: border-box;
      width: 561px;
      height: 227px;
    }
  }
  .details {
    margin: 0 auto;
    padding-top: 80px;
    width: 1200px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
    }
    .content {
      // display: flex;
      margin-top: 50px;
      img:nth-child(1) {
        width: 740px;
        height: 290px;
        margin-right: 40px;
      }
      img:nth-child(2) {
        width: 420px;
        height: 290px;
      }
    }
    .desc {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #80889a;
      line-height: 40px;
      margin-top: 50px;
      padding-bottom: 70px;
    }
  }
  .tiny {
    width: 100%;
    min-width: 1200px;
    padding-top: 133px;
    padding-bottom: 80px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
    }
    .content {
      display: flex;
      justify-content: space-around;
      margin-top: 40px;
      .list {
        width: 360px;
        height: 240px;
        width: 20%;
        background: #d8d8d8;
        border: 8px solid #fafafa;
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .oldWorld{
      display: none;
    }
    .introduce{
      width: 100%;
      margin-top: 0;
      padding: 1px 48px;
      margin-bottom: 0;
      .title{
        margin-top: 80px;
      }
      .line {
        margin-top: 22px;
        margin-bottom: 335px;
        border-left: 170px solid #fdd917;
        border-right: 441px solid #c2bebe;
        height: 1px;
        width: 0px;
        position: relative;
        z-index: 2;
        margin-left: -13px;
      }
      .content{
        display: block;
        > div{
          width: 100%;
          font-size: 28px;
          margin-top: 40px;
          padding: 0;
        }
        > div:nth-child(2){
          width: 100%;
          margin-top: 60px;
          margin-bottom: 80px;
          padding: 0;
        }
      }
      .img{
        width: 645px;
        height: 248px;
        top: 200px;
        left: 45px;
        right: auto;
        bottom: auto;
        border: none;
      }
    }
    .details{
      padding: 0 48px;
      width: 100%;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .content{
        margin-top: 80px;
        img:nth-child(1) {
          width: 410px;
          height: 160px;
          margin-right: 12px;
        }
        img:nth-child(2) {
          width: 230px;
          height: 160px;
        }
      }
      .desc{
        margin-top: 40px;
        font-size: 28px;
        line-height: 40px;
        padding-bottom: 80px;
      }
    }
    .constitute{
      background-color: #9AA4B9;
    }
  }
}
</style>
